import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'whiteboards.editor.comments.view-profile': {
    id: 'whiteboards.editor.comments.view-profile',
    defaultMessage: 'View Profile',
    description:
      'The button shown at the bottom of a profile card when you click on the mention of a user.',
  },
  'whiteboards.editor.comments.give-kudos': {
    id: 'whiteboards.editor.comments.give-kudos',
    defaultMessage: 'Give Kudos',
    description:
      'The button shown at the bottom of a profile card when you click on the mention of a user.',
  },
});
